import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import {
  RoomStageLayoutDeferredErrorVO,
  RoomStageLayoutFocusDeleteCmd,
  RoomStageLayoutFocusSetCmd,
  RoomStageLayoutMainDeleteCmd,
  RoomStageLayoutMainSetCmd,
  RoomStageLayoutUpdateVO
} from "@youm-front/room/domain";
import { RoomStageLayoutActions } from "../actions";
import { RoomStageLayoutEvents } from "../events";
import { RoomStageLayoutSelectors } from "../selectors";
import { RoomStageLayoutState } from "../reducers";

@Injectable()
export class RoomStageLayoutFacade {
  state$ = this.store.pipe(select(RoomStageLayoutSelectors.state));
  isLoading$ = this.store.pipe(select(RoomStageLayoutSelectors.isLoading));
  layout$ = this.store.pipe(select(RoomStageLayoutSelectors.layout));
  focus$ = this.store.pipe(select(RoomStageLayoutSelectors.focus));
  main$ = this.store.pipe(select(RoomStageLayoutSelectors.main));

  constructor(private readonly store: Store) {}

  roomStageLayoutDeferredErrorEvent(
    roomStageLayoutDeferredErrorVO: RoomStageLayoutDeferredErrorVO
  ) {
    this.store.dispatch(
      RoomStageLayoutEvents.roomStageLayoutDeferredErrorEvent({
        roomStageLayoutDeferredErrorVO
      })
    );
  }

  roomStageLayoutFocusDelete(
    roomStageLayoutState: RoomStageLayoutState,
    roomStageLayoutFocusDeleteCmd: RoomStageLayoutFocusDeleteCmd
  ) {
    this.store.dispatch(
      RoomStageLayoutActions.roomStageLayoutFocusDelete({
        roomStageLayoutState,
        roomStageLayoutFocusDeleteCmd
      })
    );
  }

  roomStageLayoutFocusSet(
    roomStageLayoutState: RoomStageLayoutState,
    roomStageLayoutFocusSetCmd: RoomStageLayoutFocusSetCmd
  ) {
    this.store.dispatch(
      RoomStageLayoutActions.roomStageLayoutFocusSet({
        roomStageLayoutState,
        roomStageLayoutFocusSetCmd
      })
    );
  }

  roomStageLayoutMainDelete(
    roomStageLayoutState: RoomStageLayoutState,
    roomStageLayoutMainDeleteCmd: RoomStageLayoutMainDeleteCmd
  ) {
    this.store.dispatch(
      RoomStageLayoutActions.roomStageLayoutMainDelete({
        roomStageLayoutState,
        roomStageLayoutMainDeleteCmd
      })
    );
  }

  roomStageLayoutMainSet(
    roomStageLayoutState: RoomStageLayoutState,
    roomStageLayoutMainSetCmd: RoomStageLayoutMainSetCmd
  ) {
    this.store.dispatch(
      RoomStageLayoutActions.roomStageLayoutMainSet({
        roomStageLayoutState,
        roomStageLayoutMainSetCmd
      })
    );
  }

  roomStageLayoutUpdate(
    roomStageLayoutState: RoomStageLayoutState,
    roomStageLayoutUpdateVO: RoomStageLayoutUpdateVO
  ) {
    this.store.dispatch(
      RoomStageLayoutActions.roomStageLayoutUpdate({
        roomStageLayoutState,
        roomStageLayoutUpdateVO
      })
    );
  }
}
